import React from 'react';
import PropTypes from 'prop-types';
import { Container, Theme } from '../../legacy/hui/src/styled';
import styled from 'styled-components';

const NavContainer = styled(Container)`
  background-color: ${Theme.snow};
  min-height: 50px;
  box-shadow: 0 1px 0 0 #c6c6c7;
  border-top: 1px solid #eee;
  position: relative;
  text-align: center;

  @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
    text-align: left;
    box-shadow: none;
    border: 0 none;
    background-color: transparent;
    height: auto;
    min-height: 20px;
  }
`;
const NavTitle = styled.h3`
  color: #333437;
  font-size: 14px;
  font-weight: 500;
  margin: 6px auto 0;

  @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
    margin: 0;
    color: ${Theme.dark};
    font-size: 20px;
    margin-top: 10px;
  }
`;

const JobDetailsLink = styled.a`
  color: #f55811;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0 auto;

  @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
    display: none;
  }
`;

export class SuccessPageNav extends React.Component {
  static propTypes = {
    tradie: PropTypes.string,
    location: PropTypes.string
  };

  render() {
    const { tradie, location } = this.props;
    return (
      <NavContainer>
        <NavTitle>
          {tradie} in {location}
        </NavTitle>
        <JobDetailsLink href="#jbt">Job Details</JobDetailsLink>
      </NavContainer>
    );
  }
}
